import { SharedAngular } from '@Client/@types/sharedAngular';
import angular from 'angular';
import { IStateParamsService, IStateProvider } from 'angular-ui-router';

angular.module('flowingly.runner.procedures').config(config);

config.$inject = ['$stateProvider'];

function config($stateProvider: IStateProvider) {
  $stateProvider.state('app.runner.procedure', {
    url: 'sops/{procedureId}?edit',
    params: {
      title: 'Procedure'
    },
    controller: 'procedureController',
    controllerAs: '$ctrl',
    templateUrl: 'Client/runner.procedures/runner.procedure.tmpl.html',
    resolve: {
      procedure: [
        'procedureApiService',
        '$stateParams',
        function (
          procedureApiService: SharedAngular.ProcedureApiService,
          $stateParams: IStateParamsService
        ) {
          const isEditing = $stateParams.edit === 'true';
          const recordView = !isEditing;
          return procedureApiService.getProcedure(
            $stateParams.procedureId,
            recordView,
            isEditing
          );
        }
      ]
    }
  });
}
